module.exports = __webpack_public_path__ + "static/media/phone-plus.6d28c6bc.svg";